var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('div',{attrs:{"id":"map"}}):_c('div',[_vm._v(_vm._s(_vm.$t('sensors.locationGPSInfo')))])
}
var staticRenderFns = []

export { render, staticRenderFns }